(function () {
  function initFlexibleSection(root = document) {
    root.querySelectorAll('[data-flexible-section]').forEach((section) => {
      if (section.dataset.flexibleSectionInit === 'true') return

      const tabTriggers = section.querySelectorAll('[data-flexible-tab-trigger]')
      const tabPanels = section.querySelectorAll('[data-flexible-tab-panel]')

      if (!tabTriggers.length || !tabPanels.length) return

      const playAutoplayVideos = (panel) => {
        panel.querySelectorAll('video[autoplay]').forEach((video) => {
          video.muted = true

          const playPromise = video.play()
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {
            })
          }
        })
      }

      const setActiveTab = (nextIndex) => {
        tabTriggers.forEach((tab, index) => {
          const isActive = index === nextIndex
          tab.setAttribute('aria-selected', String(isActive))
        })

        tabPanels.forEach((panel, index) => {
          const isActive = index === nextIndex
          panel.classList.toggle('is-active', isActive)
          panel.hidden = !isActive

          if (!isActive) {
            panel.querySelectorAll('video').forEach((video) => {
              video.pause()
            })
          } else {
            playAutoplayVideos(panel)
          }
        })
      }

      tabTriggers.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          setActiveTab(index)
        })
      })

      setActiveTab(0)
      section.dataset.flexibleSectionInit = 'true'
    })
  }

  document.addEventListener('DOMContentLoaded', () => {
    initFlexibleSection()
  })

  document.addEventListener('shopify:section:load', (event) => {
    initFlexibleSection(event.target)
  })
})()